import { render, staticRenderFns } from "./CMEditRemindSetting.vue?vue&type=template&id=1bf4516f&"
import script from "./CMEditRemindSetting.vue?vue&type=script&lang=js&"
export * from "./CMEditRemindSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf4516f')) {
      api.createRecord('1bf4516f', component.options)
    } else {
      api.reload('1bf4516f', component.options)
    }
    module.hot.accept("./CMEditRemindSetting.vue?vue&type=template&id=1bf4516f&", function () {
      api.rerender('1bf4516f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMEditRemindSetting.vue"
export default component.exports